import { render } from "./GefahrgutView.vue?vue&type=template&id=2cf633a4"
import script from "./GefahrgutView.vue?vue&type=script&lang=js"
export * from "./GefahrgutView.vue?vue&type=script&lang=js"

import "./GefahrgutView.vue?vue&type=style&index=0&id=2cf633a4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__